import React from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line react/prop-types
function FormGroup({ children, style }) {
  return <div className="form-group" style={style}>{children}</div>;
}

FormGroup.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
};

export default FormGroup;
